export const GET_COMMENT_SENDING = 'GET_COMMENT_SENDING';
export const GET_COMMENT_SUCCESS = 'GET_COMMENT_SUCCESS';
export const GET_COMMENT_FAILED = 'GET_COMMENT_FAILED';

export const CREATE_COMMENT_SENDING = 'CREATE_COMMENT_SENDING';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAILED = 'CREATE_COMMENT_FAILED';